//

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { catchError } from 'rxjs';
import { HandleError } from 'src/app/utils/network-error-handler';

@Injectable()
export class ConnectorZBEQuickActionsSyncSageService {

    constructor(private httpClient: HttpClient, private apiService: ApiService) {
    }

    doGetRunnerTasksAction_BOAdmSageLink(_taskID : number){
        return this.httpClient.post(this.apiService.endPointsBO.doGetRunnerTasksAction_BOAdmSageLink, { TASKS_IDS : [_taskID] }).pipe(catchError(error => HandleError(error)));
    }

    doCancelRunnerTasksAction_BOAdmSageLink(_taskID : number){
        return this.httpClient.post(this.apiService.endPointsBO.doCancelRunnerTasksAction_BOAdmSageLink + '/' + _taskID, {});
    }

}
